import { useCallback, useReducer } from 'react';

import { map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { cloudProviderOptionsWithAll } from 'components/DataDisplay';
import { remediationTypeOptions } from 'containers/PolicyHub/Remediation/Components/utils';
import { selectRemediation } from 'containers/PolicyHub/Remediation/selector';
import { toTitleCase } from 'utils/string';

import { actions } from '../../slice';

export const useRemediation = () => {
  const dispatch = useDispatch();
  const { remediationList, currentCategory } = useSelector(selectRemediation);
  const [state, updateState] = useReducer(
    (prev, next) => {
      return { ...prev, ...next };
    },
    {
      resourceType: { label: 'Resource type', value: undefined },
      remediationType: remediationTypeOptions[0],
      cloud: cloudProviderOptionsWithAll[0],
      category: { label: 'Alert category', value: undefined },
      categoryOptions: [],
    },
  );
  const getRemediationList = useCallback(() => {
    !!currentCategory &&
      dispatch(
        actions.getRemediationList({
          q: {
            categoryClass: state.category?.value,
            page: remediationList.page.info.page_number,
            size: remediationList.page.info.page_size,
            resourceType: state.resourceType?.value,
            isCustom:
              state?.remediationType?.value === 'custom'
                ? true
                : state?.remediationType?.value === 'standard'
                ? false
                : undefined,
            cloud: state.cloud?.value,
          },
        }),
      );
  }, [
    dispatch,
    currentCategory,
    remediationList.page.info,
    state.resourceType,
    state.remediationType,
    state.cloud,
    state.category,
  ]);

  const getRemediationCategories = useCallback(() => {
    dispatch(
      actions.getRemediationCategories({
        onSuccess: res => {
          updateState({
            categoryOptions: map(res, o => ({
              label: toTitleCase(o?.category),
              value: o?.category,
            })),
          });
        },
      }),
    );
  }, [dispatch]);

  const updateValue = (field, value) => updateState({ [field]: value });

  return {
    getRemediationList,
    getRemediationCategories,
    resourceType: state.resourceType,
    remediationType: state.remediationType,
    cloud: state.cloud,
    category: state.category,
    categoryOptions: state.categoryOptions,
    updateValue,
  };
};
